import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BreakpointService } from '@services/breakpoint.service';
import { BaseDirective } from '@shared/directives/base/base.directive';
import { LoaderComponent } from 'cve-ui';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, LoaderComponent],
    templateUrl: './app.html',
    styleUrl: './app.scss',
})
export class App extends BaseDirective {
    breakpointService = inject(BreakpointService);

    constructor() {
        super();
        this.breakpointService.set();
    }
}
